import React, { useEffect, useState } from "react";

// TODO: Implementation seems more complicated that it should be, revisit it!
function MultipleChoiceWithoutSubmit({
  question,
  choices,
  qKey,
  onChange,
  selectedChoices = {},
}) {
  const [currentChoice, setChoice] = useState(selectedChoices);

  const getExclusiveOption = () =>
    choices.find((choice) => choice.hasOwnProperty("exclusive"));

  const handleChange = (e, choice) => {
    //console.log(choice);
    const { id, value } = e.target;
    if (choice.hasOwnProperty("exclusive")) {
      setChoice({
        [id]: {
          checked: !isChecked(id),
          value: value,
          id: id,
        },
      });
    } else {
      setChoice((prevState) => {
        const exclusiveOption = getExclusiveOption();
        if (exclusiveOption) {
          delete prevState[getExclusiveOption()["id"]];
        }
        const newState = {
          ...prevState,
          [id]: {
            checked: !isChecked(id),
            value: value,
            id: id,
          },
        };
        return newState;
      });
    }
  };

  const isChecked = (choiceId) => {
    const _choiceState = currentChoice[choiceId];
    if (_choiceState && _choiceState.hasOwnProperty("checked")) {
      return _choiceState["checked"];
    } else {
      return false;
    }
  };

  useEffect(() => {
    //pass state to parent
    onChange(currentChoice);
  }, [currentChoice]);

  useEffect(() => {
    setChoice(selectedChoices);
  }, [selectedChoices]);

  const Choices = choices.map((choice, index) => {
    return (
      <li key={index}>
        <label>
          <input
            type="checkbox"
            name={qKey}
            key={choice.id}
            value={choice.value}
            id={choice.id}
            checked={isChecked(choice.id)}
            onChange={(e) => handleChange(e, choice)}
          />
          <span className="dot"></span>
          <span className="txt">{choice.text}</span>
        </label>
      </li>
    );
  });

  return (
    <>
      <h3 className="headtitle">{question}</h3>
      <ul className="list-unstyled list_checkbox_btn">{Choices}</ul>
    </>
  );
}

export default MultipleChoiceWithoutSubmit;
